import { useState, useEffect, useCallback } from "react";
import OnboardingTour from "../components/OnboardingTour";

/**
 * Hook that decides whether to render the interactive onboarding tour and
 * marks it complete via API. Single source of truth so both Franquia and
 * Loja shells stay in sync.
 *
 *   const tour = useOnboardingTour({ user, apiBase, steps });
 *   return <>... {tour} ...</>;
 */
export default function useOnboardingTour({ user, apiBase, steps, delayMs = 900, brandColor = "#FF6B00" }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!user || user.onboarding_completed) return;
    const t = setTimeout(() => setOpen(true), delayMs);
    return () => clearTimeout(t);
  }, [user, delayMs]);

  const finish = useCallback(async (skipped) => {
    setOpen(false);
    try {
      const token = localStorage.getItem("token");
      await fetch(`${apiBase}/auth/onboarding-completed`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
      });
      // Update cached user so we don't re-trigger on next mount
      try {
        const cached = JSON.parse(localStorage.getItem("user") || "null");
        if (cached) {
          cached.onboarding_completed = true;
          localStorage.setItem("user", JSON.stringify(cached));
        }
      } catch { /* ignore */ }
    } catch (e) {
      console.warn("onboarding completion failed:", e?.message);
    }
  }, [apiBase]);

  if (!open) return null;
  return (
    <OnboardingTour steps={steps} onFinish={finish} brandColor={brandColor} />
  );
}
